// @flow
import * as React from 'react';
import styled from 'styled-components';
import type { HOC as ElementType } from 'recompose';
import type { rectType } from './../../types';

const Rect = styled.div`
  position: relative;
  width: auto;
  height: ${({ height }) => `${height}px`};
`;
export const withRect = (Comp: ElementType) => ({
  height,
  width,
  ...props
}: rectType) => (
  <Rect height={height} width={width}>
    <Comp height={height} width={width} {...props} />
  </Rect>
);
